export type ProductType = {
  // TODO: remove picture field
  picture?: string;
  id: number;
  name: string;
  code: string;
  url: string;
  pictures: string[];
  price: number;
  oldPrice: number;
  brand: string;
  discountPercent: number;
  rating: number;
  countReviews: number;
  countBonus: number;
  isTrend: boolean;
  isNew: boolean;
  offers: OfferType[];
  isExclusive: boolean;
  isLimitedEdition: boolean;
  isSale: boolean;
  isGift: boolean;
  isPromo: boolean;
  quantity: number;
};

export type FinishedOrderProductType = {
  basketItemId: number;
  description: string;
  discountPercent: number;
  isGift: boolean;
  link: string;
  name: string;
  offerId: number;
  oldPrice: number;
  picture: string;
  price: number;
  productId: number;
  quantity: number;
};

export type AdvertisementType = {
  id: number;
  name: string;
  picture: string;
};

export type CategoryType = {
  id: number;
  name: string;
  picture: string;
  code: string;
  url: string;
  parent: number;
};

export type BrandType = {
  id: number;
  name: string;
  picture: string;
  pictureTablet: string;
  pictureMobile: string;
  link: string;
  code: string;
  text: string;
};

export type RelevantType = {
  name: string;
  picture: string;
  link: string;
};

export type PromotionType = {
  id: number;
  name: string;
  picture: string;
  link: string;
  text: string;
};

export type BannerType = {
  additionalPicture: string;
  button: { text: string; link: string };
  description: string;
  id: number;
  name: string;
  picture: string;
  pictureTablet: string;
  pictureMob: string;
};

export type CollectionType = {
  id: number;
  name: string;
  picture: string;
  link: string;
};

export type CatalogItem = {
  id: number;
  name: string;
  picture: string;
  code: string;
  url: string;
  parent: number | null;
  promo: boolean;
};

type DefaultFilterValueType = {
  code: string;
  iblockId: number | null;
  name: string;
  hint: string;
  propertyType: string | null;
};

export type FilterRangeType = DefaultFilterValueType & {
  displayType: FilterType.Range | FilterType.PriceRange | null;
  values: {
    min: number;
    max: number;
  };
};

export type FilterSelectType = DefaultFilterValueType & {
  displayType: FilterType.Select | null;
  values: {
    htmlValue: string;
    value: string;
    urlId: string;
    facetValue: string;
    count: string;
  }[];
};

export type FilterFieldsType = Record<
  string,
  FilterRangeType | FilterSelectType
>;

export enum FilterType {
  Range = 'A',
  PriceRange = 'R',
  Select = 'P',
}

export type SelectFilterObjectType = {
  [key: string]: {
    values: string[];
  };
};

export type RangeFilterObjectType = {
  [key: string]: {
    values: { min: number; max: number };
  };
};

export type Pagination = {
  page: number;
  count: number;
  countPages: number;
  countElements: number;
};

export type CharacteristicsType = {
  text: string;
  article: string;
  items: {
    name: string;
    value: string;
  }[];
};

export type SizeType = {
  name: string;
  description: string;
};

export type OfferType = {
  id: number;
  name: string;
  size: SizeType;
  countKit: {
    id: number;
    name: string;
  };
  price: number;
  oldPrice: number;
  discountPercent: number;
  quantity: number;
};

export type DeliveryServiceType = {
  name: string;
  price: {
    text: string;
    value: string;
  };
  free: {
    text: string;
    value: string;
  };
  time: {
    text: string;
    value: string;
  };
};

export type SizesTableType = {
  header: string[];
  row: [string[], string[], string[], string[]];
  description: string;
};

export type ProductDetailedType = {
  id: number;
  name: string;
  code: string;
  url: string;
  link: string;
  pictures: string[];
  price: number;
  oldPrice: number;
  brand: {
    id: number;
    name: string;
    picture: string;
    code: string;
    link: string;
  };
  discountPercent: number;
  quantity: number;
  characteristics: CharacteristicsType;
  offers: OfferType[];
  color: string;
  careProduct: {
    text: string;
  };
  returnProduct: {
    text: string;
  };
  delivery: DeliveryServiceType[];
  tableSize: SizesTableType;
  rating: number;
  countReviews: number;
  countBonus: number;
  question: number;
  isTrend: boolean;
  isNew: boolean;
  isExclusive: boolean;
  isLimitedEdition: boolean;
  isSale: boolean;
  isGift: boolean;
  isPromo: boolean;
  inFavorites: boolean;
  otherColors: {
    name: string;
    code: string;
    colorCode: string | null;
    url: string;
    picture: string;
  }[];
  otherCompleteness: {
    id: number;
    name: string;
    url: string;
  }[];
  categoryId: number;
};

export type SortFilterType = {
  name: string;
  code: string;
};

export type FooterLinkProps = {
  text: string;
  url: string;
  onClick?: () => void;
};

export type UserType = {
  id: number;
  websiteId?: string;
  picture: string;
  lastName: string;
  name: string;
  secondName: string;
  email: string;
  phone: string;
  phoneIsConfirm: boolean;
  birthday: string;
  orderInformation: boolean;
  subscribes: boolean;
};

export type QuestionType = {
  id: number;
  date: string;
  question: string;
  answer: string;
  isAnonymous: boolean;
  user: UserType;
};

export type ReviewType = {
  id: number;
  date: string;
  photo: string[];
  advantages: string;
  flaws: string;
  description: string;
  isAnonymous: boolean;
  rating: number;
  countLike: number;
  countDislike: number;
  userHaveLike: boolean;
  userHaveDislike: boolean;
  user: UserType;
};

export type FaqBlockType = {
  id: number;
  sort: number;
  name: string;
  description: string;
};

export type TypicalPageType = {
  id: number;
  name: string;
  code: string;
  banner: {
    picture: string;
    description: string;
  };
  description: string;
  faq: FaqBlockType[];
};

export type InformationType = {
  name: string;
  description: string;
  characteristics: {
    name: string;
    value: string;
  }[];
};

export type AboutPageType = {
  name: string;
  picture: string;
  description: string;
  contacts: {
    name: string;
    description: string;
  }[];
};

export type SocialLinkType = {
  icon: string | null;
  link: string | null;
  id: number;
};

export type HeaderLinkType = {
  id: number;
  name: string;
  link: string;
  parent: number | null;
};

export type FooterLinkType = {
  id: number;
  name: string;
  link: string;
  parent: number | null;
};

export type SettingsType = {
  social: {
    title: string;
    icons: SocialLinkType[];
  };
  copyRight: string;
  cookies: string;
  pickupReadyInterval: number;
  pickupAddress: string | null;
  pickupWorktime: string | null;
  pickupNote?: string | null;
};

export type SectionType = {
  id: number;
  name: string;
  picture: string;
  code: string;
  url: string;
  parent: number | null;
};

export type GiftType = {
  id: number;
  name: string;
  code: string;
  url: string;
  categoryId: number;
  pictures: string[];
  price: number;
  oldPrice: number;
  brand: string;
  discountPercent: number;
  rating: number;
  countReviews: number;
  countBonus: number;
  isTrend: boolean;
  isNew: boolean;
  isExclusive: boolean;
  isLimitedEdition: boolean;
  isSale: boolean;
  isGift: boolean;
  giftPriceFrom: number;
};

export type StockType = {
  id: number;
  name: string;
  code: string;
  picture: string;
  dateActiveTo: string | null;
  dateActiveFrom: string | null;
  previewText: string;
  text: string;
};

export type OrderType = {
  addedBonuses: number;
  cancelAt: string | null;
  completedAt: string | null;
  createdAt: string;
  delivery: {
    address: string;
    name: string;
    type: string;
    price: number;
    date: string;
    readyDate: string | null;
  };
  discount: number;
  id: number;
  payment: {
    name: string;
    isPaid: boolean;
    certificate: string;
  };
  products: FinishedOrderProductType[];
  recipient: {
    name: string;
    phone: string;
    email: string;
    anotherPersonName: string;
  };
  status: {
    name: string;
    code: StatusCodes;
  };
  totalPrice: number;
  totalWeight: number;
};

export enum StatusCodes {
  Delivered = 'DF',
  Draft = 'DR',
  Accepted = 'N',
  Completed = 'F',
  Returned = 'R',
  Pending = 'DN',
  Assembling = 'S',
  Canceled = 'C',
  Delivering = 'DD',
  ReadyForPickup = 'RP',
}

export type ObjectType = {
  id: number;
  code: string;
  text: string;
  picture: string;
  pictureMob: string;
  tag: string;
  button: string;
  buttonLink: string;
  buttonDisabled: boolean;
  info: string;
  alert: string | null;
  techClosed: boolean;
};

export type TicketType = {
  id: number;
  name: string;
  text: string;
  help: string;
  price: number;
  numberOfPersons: number;
  button: string;
  link: string;
};

export type CartContentType = {
  userId: number;
  price: number;
  oldPrice: number;
  promocode: string;
  bonuses: {
    available: number;
    total: number;
    used: number;
    addedBonuses: number;
  };
  useBonus: boolean;
  freeDeliveryPrice: number;
  freeDeliveryPriceActive: boolean;
  deliveryPrice: number;
  countBasketItems: number;
  basketItems: CartItemType[];
  discount: number;
  certificate: string;
};

export type CartItemType = {
  basketItemId: number;
  productId: number;
  quantity: number;
  price: number;
  oldPrice: number;
  discountPercent: number;
  name: string;
  link: string;
  picture: string;
  offerId: number;
  description: string;
  isGift: boolean;
};

export type DeliveryType = {
  id: number;
  name: string;
  code: string;
  description: string;
};

export type PaymentType = {
  id: number;
  name: string;
  code: string;
  description: string;
};

export type BackendBreadcrumbType = {
  name: string;
  url: string;
};

export type LocationType = {
  id: number;
  name: string;
};

export type AddressType = {
  address: string;
  apartmentNumber: string;
  entrance: string;
  floor: string;
  comment: string;
  default: boolean;
  coordinates: string;
  id?: number;
  city: string;
};

export type RecipientType = {
  fio: string;
  email: string;
  phone: string;
  anotherPerson: boolean;
  anotherPersonFio: string;
};

export type OrderDataType = {
  delivery: {
    type: string;
    city: string;
    address: AddressType | null;
    pickup: {
      id: number | null;
    };
  };
  recipient: RecipientType | null;
  payment: {
    type: string;
    certificate: string;
  };
};

export type PickupPointType = {
  address: string;
  comment: string | null;
  id: number | null;
  latitude: number;
  longitude: number;
  name: string;
  note: string | null;
  phone: string;
  worktime: string;
};

export type SearchHintType = {
  id: number;
  date: string;
  name: string;
};

export type RefundType = {
  date: string;
  id: number;
  orderId: number;
};

export type RefundReasonType = {
  id: number;
  name: string;
  sort: number;
};

export type CancelReasonType = {
  id: number;
  name: string;
  sort: number;
};

export type OperationType = {
  date: string;
  comment: string;
  amount: string;
  burnDate: string | null;
  availabilityDate: string;
  status: string;
};

export type BalanceType = {
  available: number;
  spent: number;
  total: number;
};

export type RefundOrderType = {
  id: number;
  orderId: number;
  product: FinishedOrderProductType;
  reason: { name: string; description: string; photos: string[] };
  status: string;
  answer: string | null;
  date: string;
};
